import React, {FC} from "react"

import id from "@irati/utils/id"

import {IconButton} from "./styled"

type Props = {
  slidesToShow?: number,
  onClick?: () => void,
  slideCount?: number,
  currentSlide?: number,
  show?: boolean,
  previousNav?: boolean,
  alwaysShow?: boolean,
  id?: string
}

const SliderNav: FC<Props> = ({
  currentSlide= 0,
  slideCount = 0,
  slidesToShow=  0,
  onClick = () => {},
  show = true,
  ...props
}) => {
  const {previousNav, alwaysShow} = props
  const idNamespace = id("slider-nav", props)

  if (!show) {
    return null
  }

  if (!alwaysShow) {
    // disable next
    if (!previousNav && slideCount! <= (currentSlide! + slidesToShow)) {
      return null
    }

    // disable prev
    if (previousNav && currentSlide! <= 0) {
      return null
    }
  }

  return (
    <IconButton
      id={idNamespace}
      previousNav={previousNav}
      onClick={onClick}
      icon={previousNav ? "angleLeft" : "angleRight"} />
  )
}

export default SliderNav
